import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

function initState() {
  return {
    authenticated: false,

    user: {
      email: '',
      firstname: '',
      lastname: '',
      salutation: '',
      title: ''
    },

    userRole: '',
    currentClient: {},
    
    clients: []
  }
}

export { initState }

export default new Vuex.Store({
  state: initState(),
  getters,
  mutations,
  actions
})